import React, { createContext, useState, useEffect } from 'react';
import api from './AxiosConfig'; 

export const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [isLoggedIn, setIsLoggedIn]       = useState(false);
  const [user,      setUser]              = useState(null);
  const [isAdmin,   setIsAdmin]           = useState( false );
  const [userType,  setUserType]          = useState( 0 );
  const [clSummary, setClSummary]         = useState( false );
  const [isLoading, setIsLoading]         = useState( true );
  const [lastDismissed, setLastDismissed] = useState( 0 );
  
  const getUserId = async () => {
      return( user );
  }
  
  // Check Session function
  const checkSession = async () => {
      try {
          const response = await api.get('/site/check-session', { withCredentials: true });

          if (response.data.isLoggedIn) {
              setIsLoggedIn(true);
              setUser( response.data.userId );
              setIsAdmin( response.data.isAdmin );
              setLastDismissed( Number(response.data.system_message_last_dismiss) );
              setIsLoading( false );
          } else {
              setIsLoggedIn(false);
              setIsAdmin(false);
          }
      } catch (error) {
          console.error('Error checking session:', error);
          setIsLoggedIn(false);
      }
      return( { success: isLoggedIn, isAdmin: isAdmin } );
  };
  
  // Login function
  const login = async (username, password) => {
    try {
        const response = await api.post('/site/login', { email: username, password: password }, { withCredentials: true } );
        if (response.status === 200) {
            setIsLoggedIn(true);
            setUser(response.data.user);
            setUserType(Number(response.data.userType));
            setIsAdmin(response.data.isAdmin);
            setClSummary(response.data.checklist_summary_enabled);
            setLastDismissed( Number(response.data.system_message_last_dismiss) );
            return { success: true };
        } else {
            return { success: false, message: response.data.message };
        }
    } catch (error) {
        console.error('Login error:', error);
        if ( error.response && error.response.data && error.response.data.message ) {
            return ( { success: false, message: error.response.data.message } );
        }
        return { success: false, message: 'System Error.' };
    }
  };
  
  // Logout function
  const logout = async () => {
      try {
          await api.post('/site/logout', {}, { withCredentials: true });
          setIsLoggedIn(false);
          setUser(null);
          setIsAdmin(false);
          return { success: true }
      } catch (error) {
          console.error('Logout error:', error);
          return { success: false, message: 'Failed to log out.' };
    }
  };

  // Password reset
  const resetPassword = async ( email ) => {
      try{
          await api.post('/site/reset-password', {email: email}, { withCredentials: true });
          return { success: true };
      } catch (error) {
          console.error('Logout error:', error);
          return { success: false, message: 'Failed process password reset.' };
      } 
  };

  useEffect(() => {
    // This function runs once, right after the component mounts.
    checkSession();
    
    // Set an interval to fetch data every minute (60000ms)
    const interval = setInterval(() => {
        checkSession();
    }, 6 * 60 * 1000); // ms
  } );
  
  return (
    <AuthContext.Provider value={{ isLoggedIn, isLoading, isAdmin, userType, clSummary, user, login, logout, resetPassword, checkSession, getUserId, lastDismissed }}>
      {children}
    </AuthContext.Provider>
  );
}
